// export class UserSession {
//     userId: number;
//     userFullName: string;
//     roleId: number;
//     authToken: string;
//     roleName: string;
//     email: string;
//     rolename:string;
//     mobileNumber: string;

// }
export class UserSession {
    id: number;
    name: string;
    mobileNo: string;
    email: string;
    institutionName:string;
    deviceId:string;
    originAddress:string;
    originStationName:string;
    destinationStationName:string;
    strFreeRideValidityStartDate:string;
    strFreeRideValidityEndDate:string;
    authToken:string;
}
